import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
export const updateBioStatus = createAsyncThunk(
  "agentRosterProfile/updateBioStatus",
  async (data, thunkAPI) => {
    const handleSuccess = data.handleSuccess;
    const handleError = data.handleError;
    try {
      const resp = await axios.put(
        `${process.env.REACT_APP_BASE_URL}api/users/update-biography-status/${data.id}`,
        data.schema,
        {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            "Content-Type": "application/json",
          },
        }
      );
      if (handleSuccess) {
        handleSuccess();
      }
      return resp.data?.user;
    } catch (error) {
      if (error.response) {
        if (handleError) {
          handleError(error.response.data.message);
        }
        return thunkAPI.rejectWithValue(error.response.data.message);
      } else {
        if (handleError) {
          handleError(error.message);
        }
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
